import React, { PureComponent } from 'react';
import T from 'i18n-react';
import { reactRouterParamsType, locationAttributesType } from '../../constants/proptype-validation';

export default class extends PureComponent {

  static displayName = 'PathNotFound';

  static propTypes = {
    params: reactRouterParamsType.isRequired,
    location: locationAttributesType.isRequired,
  }

  render() {
    const { location: { pathname, state: { originalPathname } = {}}, params: { splat }} = this.props;
    return (
      <div>
        {T.translate('errors.unhandledPath', { path: originalPathname || splat || pathname })}
      </div>
    );
  }
}
